import React, { Component, Fragment, useEffect, useState } from "react";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useTranslation, I18nextProvider } from "react-i18next";

import commingsoon from "../../assets/images/cs-bg.png";

import Header from "../../components/Header";

import { useCustomizeContext } from "../../context";

const ComingSoon = (props) => {

    const { t, i18n } = useTranslation();

    const {
        sideMenu: {
            classIsActive, setClassIsActive
        },
    } = useCustomizeContext();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setClassIsActive(false);
        document.body.classList.remove("SideMenuOpen");
    }, [classIsActive]);

    return (
        <Fragment>
            <Header />
            <div className="mainbody-content">
                <Sidebar />
                <div className="cmnsoon-main">
                    <div class="center-maincnt">
                        <div class="inr-container">
                            <div class="center-inrcnt">
                                <div className="comingsoonpage-maincnt">
                                    <div class="cmnsoon-inrcnt">
                                        <div>
                                            <img src={commingsoon} alt="Comming Soon" class="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ComingSoon;

